import { Component, Input } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'input-form',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.css'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class InputComponent {
  @Input() label: string;
  @Input() type: 'text' | 'email' | 'password' = 'text';
  @Input() id: string;
  @Input() placeholder: string;
  @Input() control: any;
  @Input() estadoControl: boolean;

  constructor() {
    // this.type = 'text';
    this.placeholder = '';
    this.label = '';
    this.id = '';
    this.estadoControl = true;
  }
}
